/* Complete-the-look switch + bundle tier price correction */
(function () {
  'use strict';

  var R = window.lpRoutes || {};

  function ajax(url, fallback) {
    var u = url || fallback;
    if (u.indexOf('?') > -1) u = u.split('?')[0];
    if (u.slice(-3) !== '.js') u += '.js';
    return u;
  }
  var ADD = ajax(R.cartAdd, '/cart/add');
  var CHANGE = ajax(R.cartChange, '/cart/change');
  var CART = (R.cart || '/cart').split('?')[0];

  /* ============================================================
     Bundle tier prices
     Shopify allocates a percentage discount per unit and rounds
     each unit to the cent, then multiplies. Working from the line
     total instead drifts by a cent or two, which is why the cart
     disagreed with the product page. Mirror Shopify's order here.
     ============================================================ */
  function money(cents, format) {
    var amount = (cents / 100).toFixed(2);
    var parts = amount.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var value = parts.join('.');
    if (!format) return '$' + value;
    return format.replace(/\{\{\s*amount[^}]*\}\}/, value);
  }

  function repriceAll() {
    [].slice.call(document.querySelectorAll('[data-lp-variants]')).forEach(function (root) {
      var node = root.querySelector('[data-lp-variant-json]');
      if (!node) return;
      var data;
      try { data = JSON.parse(node.textContent); } catch (err) { return; }

      var idField = root.querySelector('[name="id"]');
      if (!idField) return;
      var current = Number(idField.value);
      var variant = (data.variants || []).filter(function (v) { return v.id === current; })[0];
      if (!variant) return;

      var unit = variant.price;
      var fmt = data.money_format;

      [].slice.call(root.querySelectorAll('[data-lp-tier]')).forEach(function (tier) {
        var q = Number(tier.getAttribute('data-lp-tier-qty')) || 1;
        var keep = Number(tier.getAttribute('data-lp-tier-percent'));
        if (!keep) keep = 100;

        /* per-unit discount, rounded to the cent, exactly as Shopify does */
        var offPct = 100 - keep;
        var unitOff = Math.round(unit * offPct / 100);
        var unitNet = unit - unitOff;
        var total = unitNet * q;
        var saving = unit * q - total;

        var tEl = tier.querySelector('[data-lp-tier-total]');
        var sEl = tier.querySelector('[data-lp-tier-save]');
        if (tEl) tEl.textContent = money(total, fmt);
        if (sEl) sEl.innerHTML = saving > 0 ? 'Save ' + money(saving, fmt) : '&mdash;';
      });
    });
  }

  /* run after the main script has done its own pass */
  function scheduleReprice() { setTimeout(repriceAll, 0); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleReprice);
  } else {
    scheduleReprice();
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-lp-opt]') || e.target.closest('[data-lp-tier]')) scheduleReprice();
  });
  document.addEventListener('shopify:section:load', scheduleReprice);

  /* ============================================================
     Complete-the-look switch
     ============================================================ */
  var busy = false;

  function post(url, payload) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) {
      if (!r.ok) throw new Error('cart');
      return r.json();
    });
  }

  function findKey(variantId) {
    return fetch(CART + '.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var hit = (cart.items || []).filter(function (i) { return i.variant_id === variantId; })[0];
        return hit ? hit.key : '';
      })
      .catch(function () { return ''; });
  }

  function syncDrawer() {
    return fetch(CART + '?section_id=lp-cart-drawer-section', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-lp-drawer-inner]');
        var live = document.querySelector('[data-lp-drawer-inner]');
        if (fresh && live) live.innerHTML = fresh.innerHTML;
        var c = doc.querySelector('[data-lp-cart-count]');
        [].slice.call(document.querySelectorAll('[data-lp-cart-count]')).forEach(function (n) {
          if (c) n.textContent = c.textContent;
        });
      })
      .catch(function () {});
  }

  function setState(wrap, btn, status, on, msg) {
    wrap.classList.toggle('is-on', on);
    btn.setAttribute('aria-checked', on ? 'true' : 'false');
    if (status) status.textContent = msg || '';
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-lp-ctl]');
    if (!btn) return;
    e.preventDefault();
    if (busy) return;
    busy = true;

    var wrap = btn.closest('[data-lp-ctl-wrap]');
    var status = wrap.querySelector('[data-lp-ctl-status]');
    var id = Number(btn.getAttribute('data-lp-ctl-id'));
    var key = btn.getAttribute('data-lp-ctl-key');
    var wasOn = btn.getAttribute('aria-checked') === 'true';

    wrap.classList.add('is-busy');
    if (status) status.textContent = '';

    var job;
    if (wasOn) {
      job = (key ? Promise.resolve(key) : findKey(id))
        .then(function (k) {
          if (!k) return null;
          return post(CHANGE, { id: k, quantity: 0 });
        })
        .then(function () {
          btn.setAttribute('data-lp-ctl-key', '');
          setState(wrap, btn, status, false, '');
        });
    } else {
      job = post(ADD, { items: [{ id: id, quantity: 1 }] })
        .then(function () { return findKey(id); })
        .then(function (k) {
          btn.setAttribute('data-lp-ctl-key', k);
          setState(wrap, btn, status, true, 'Added to your bag');
        });
    }

    job
      .catch(function () {
        return findKey(id).then(function (k) {
          btn.setAttribute('data-lp-ctl-key', k);
          setState(wrap, btn, status, !!k, k ? 'Added to your bag' : '');
        });
      })
      .then(function () {
        wrap.classList.remove('is-busy');
        busy = false;
        return syncDrawer();
      });
  });
})();
